import React from "react";
import Fade from "react-reveal/Fade";
import { BsFillStarFill } from "react-icons/bs";

/** Affiche exactement 3 témoignages côte à côte, sans carousel ni défilement */
function Testimonial() {
  const threeTestimonials = Data.slice(0, 3);
  return (
    <div className="testimonial-grid-static">
      {threeTestimonials.map((testimonial) => (
        <TestimonialItem item={testimonial} key={testimonial.id} />
      ))}
    </div>
  );
}

export default Testimonial;

export interface TestimonialDataItem {
  id: number;
  text: string;
  name: string;
  /** Afficher un tiret devant le nom (ex: "- Aïssatou D") */
  withHyphen?: boolean;
}

export const TestimonialItem = ({ item }: { item: TestimonialDataItem }) => {
  const displayName = item.withHyphen ? `- ${item.name}` : item.name;
  return (
    <Fade bottom cascade>
      <div className="container-testimonial-item testimonial-card-allintech">
        <div className="content-img-icon-testimonial testimonial-quote-mark">
          <span className="testimonial-quote-char">"</span>
        </div>
        <div className="container-text-testimonial py-4">
          <p className="text-item-testimonial">{item.text}</p>
        </div>
        <div className="content-footer-testimonial w-100">
          <p className="m-0 name-user-testimonial">{displayName}</p>
          <div className="content-item-footer-testimonial testimonial-stars">
            {[1, 2, 3, 4, 5].map((i) => (
              <BsFillStarFill key={i} size={14} className="icon-rate-user-testimonial" />
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
};

const Data: TestimonialDataItem[] = [
  {
    id: 1,
    text: "Très satisfaite de mes achats sur All In Tech ! Livraison rapide et produits conformes aux descriptions. Je recommande !",
    name: "Aïssatou D",
    withHyphen: true,
  },
  {
    id: 2,
    text: "Super marketplace ! Le site est facile à utiliser et le service client est réactif. Je commanderai encore.",
    name: "Mamadou S",
  },
  {
    id: 3,
    text: "J'adore All In Tech ! Les produits sont de qualité et j'ai reçu mon colis en parfait état.",
    name: "Fatou N",
  },
  {
    id: 4,
    text: "Excellente expérience d'achat. Prix compétitifs et livraison soignée. Je reviendrai.",
    name: "Ibrahima K",
  },
  {
    id: 5,
    text: "Une référence pour le high-tech au Sénégal. Service sérieux et à l'écoute.",
    name: "Aminata M",
    withHyphen: true,
  },
];
